import React from 'react';
import { TabsBox, TabHeaderWrapper, TabContentWrapper, TabContent, TabComponent, } from './styled';
import TabItem from './components/TabItem';
export default class Tabs extends React.Component {
    constructor(props) {
        super(props);
        this.handleItem = (id) => {
            this.setState({ activeTab: id });
            this.props.onSelectedTab(id);
        };
        this.state = {
            tabsData: this.props.tabsData,
            activeTab: this.props.activeTab,
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            this.setState({
                tabsData: nextProps.tabsData,
                activeTab: nextProps.activeTab,
            });
        }
    }
    render() {
        const { tabsData } = this.state;
        const { hideTabContent } = this.props;
        const getClassByType = (type) => (this.props.classes && this.props.classes[type]) || '';
        const isActiveTab = (id) => id === this.state.activeTab;
        return (React.createElement(TabsBox, { className: `Tabs d-flex flex-column ${this.props.themeType} ${getClassByType('tabsBox')}` },
            React.createElement(TabHeaderWrapper, { className: `tab-header d-flex ${getClassByType('tabHeader')}` },
                React.createElement("ul", { className: "nav nav-tabs" }, tabsData.map((tab) => (React.createElement(TabItem, { tab: tab, isActiveTab: isActiveTab(tab.id), handleItem: this.handleItem, key: tab.id }))))),
            !hideTabContent && (React.createElement(TabContentWrapper, { className: `wrapper-content ${getClassByType('tabContent')}` },
                React.createElement(TabContent, { className: `tab-content ${getClassByType('tabContentInner')}` }, tabsData.map((tab) => (React.createElement(TabComponent, { id: tab.name, key: tab.id, className: `${isActiveTab(tab.id) ? '' : 'hidden-xs-up'} ${getClassByType('tabComponent')}` }, tab.component))))))));
    }
}
